import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import { PopulatedBeforeAndAfterProject } from "../../__generated__/types";

export const GET_BEFORE_AND_AFTER_PROJECTS = gql`
  query GetBeforeAndAfterProjects($designerId: ID!) {
    getBeforeAndAfterProjects(designerId: $designerId) {
      _id
      afterImage {
        _id
        name
        path
        url
        title
        credit
        description
      }
      beforeImage {
        _id
        name
        path
        url
        title
        credit
        description
      }
      coverImage {
        _id
        name
        path
        url
        title
        credit
        description
      }
      afterImages {
        _id
        name
        path
        url
        title
        credit
        description
      }
      budgetRange
      description
      name
      displayOrder
      projectCategory
      projectDuration
      specialRequirements
      squareFootage
      style
      featuredOnBio
      published
    }
  }
`;

export const useGetBeforeAndAfterProjectsQuery = () => {
  const [getBeforeAndAfterProjectsQuery, { loading, data }] = useLazyQuery(
    GET_BEFORE_AND_AFTER_PROJECTS
  );

  const getBeforeAndAfterProjects = useCallback(
    async (designerId: string, refresh: boolean = false) => {
      const result = await getBeforeAndAfterProjectsQuery({
        variables: {
          designerId,
        },
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      return result?.data?.getBeforeAndAfterProjects;
    },
    [getBeforeAndAfterProjectsQuery]
  );

  const beforeAndAfterProjects =
    data?.getBeforeAndAfterProjects as PopulatedBeforeAndAfterProject[];

  return {
    getBeforeAndAfterProjects,
    loading,
    beforeAndAfterProjects,
  };
};
